import i18next from "i18next";
import moment from "jalali-moment";
import persianJs from "persianjs";
import { useTranslation } from "react-i18next";
export const isEmpty = (value) => {
	try {
		return typeof value === "undefined" || value === null || value === "" || value === "NaN";
	} catch (error) {
		return true;
	}
};
export const isEmptyObject = (value) => {
	try {
		return Object.keys(value).length === 0;
	} catch (error) {
		return true;
	}
};
export const isEmptyArray = (value) => {
	try {
		return Array.isArray(value) && value.length === 0;
	} catch (error) {
		return true;
	}
};
export const convertCurrencyToRial = (value) => {
	try {
		return value * 10;
	} catch (error) {
		return 0;
	}
};
export const convertCurrencyToToman = (value) => {
	try {
		return value / 10;
	} catch (error) {
		return 0;
	}
};
export const commaDigits = (value) => {
	return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
export const complexDigitToman = (value) => {
	try {
		if (!isEmpty(value)) {
			const convertedValue = convertCurrencyToToman(parseInt(value));
			const formattedValue = commaDigits(Math.round(convertedValue));
			return formattedValue;
		}
		return 0;
	} catch (error) {
		return 0;
	}
};
export const complexDigitRial = (value) => {
	try {
		if (!isEmpty(value)) {
			const convertedValue = convertCurrencyToRial(parseInt(value));
			const formattedValue = commaDigits(Math.round(convertedValue));
			return formattedValue;
		} else {
			return 0;
		}
	} catch (error) {
		return 0;
	}
};
export const convertPersian = (value) => {
	try {
		return persianJs(value.toString()).toEnglishNumber();
	} catch (error) {
		return value;
	}
};
export const convertMemory = (value, fromUnit, toUnit) => {
	// تبدیل واحد از ورودی به بایت
	const units = {
		B: 1,
		KB: 1024,
		MB: 1024 * 2,
		GB: 1024 * 3,
		TB: 1024 * 4,
		// اضافه کردن واحدهای دیگر در صورت نیاز
	};

	// بررسی وجود واحدها
	if (!units[fromUnit] || !units[toUnit]) {
		return "Invalid units!";
	}

	// تبدیل به بایت
	const bytes = value * units[fromUnit];

	// تبدیل از بایت به واحد مورد نظر
	return bytes / units[toUnit];

	// console.log(convertBytes(1024, 'kilobyte', 'megabyte')); // خروجی: 1
	// console.log(convertBytes(1, 'gigabyte', 'megabyte')); // خروجی: 1024
	// console.log(convertBytes(1000, 'kilobyte', 'byte')); // خروجی: 1024000
};

export const days_Difference = (fromDate, toDate) => {
	const oneDay = 24 * 60 * 60 * 1000; // تعداد میلی‌ثانیه‌های یک روز

	// تبدیل تاریخ‌ها به شیء تاریخ جاوا اسکریپت
	const dateObject1 = new Date(fromDate);
	const dateObject2 = new Date(toDate);

	// محاسبه تعداد روزهای اختلاف
	const diffDays = Math.round(Math.abs((dateObject1 - dateObject2) / oneDay));

	return diffDays;
};
export const gregorian_to_jalali = (date) => {
	let gregorianDate = moment(date, "YYYY-MM-DD"); // تاریخ میلادی
	let jalaliDate = gregorianDate.format("jYYYY/jMM/jDD"); // تبدیل به تاریخ شمسی
	return jalaliDate;
};
export const currentYear = (_curDate) => {
	return moment(_curDate).format("jYYYY");
};
export const jalali_to_gregorian = (date, split = "-") => {
	let jalaliDate = moment(date, "jYYYY/jMM/jDD"); // تاریخ میلادی
	let gregorianDate = jalaliDate.format(`YYYY${split}MM${split}DD`); // تبدیل به تاریخ شمسی
	return gregorianDate;
};
export const convertToJalaliWithTime = (date, spliter = "/", exportSplit = "/") => {
	try {
		let _tempDate = date?.split("T")[0].split(spliter);
		return gregorian_to_jalali(_tempDate[0] + exportSplit + _tempDate[1] + exportSplit + _tempDate[2]);
	} catch (error) {
		return "";
	}
};
export const convertToJalaliWithoutTime = (date, spliter = "/", exportSplit = "/") => {
	try {
		let _tempDate = date?.split(spliter);
		return gregorian_to_jalali(_tempDate[0] + exportSplit + _tempDate[1] + exportSplit + _tempDate[2]);
	} catch (error) {
		console.error(error);
		return "";
	}
};

export const convertToGregorian = (date, spliter = "/", exportSplit = "/") => {
	let _tempDate = date?.split(spliter);
	return jalali_to_gregorian(_tempDate[0] + "/" + _tempDate[1] + "/" + _tempDate[2], exportSplit);
};
export const formatDate = (date) => {
	var d = new Date(date),
		month = "" + (d.getMonth() + 1),
		day = "" + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = "0" + month;
	if (day.length < 2) day = "0" + day;

	return [year, month, day]?.join("-");
};
export const getMinAndMaxDateBirthday = () => {
	let d = new Date();
	let year = d.getFullYear();
	let month = d.getMonth();
	let day = d.getDate();
	let c = new Date(year - 18, month, day);

	var MaxDate = {
		year: parseInt(formatDate(c)),
		month: 11 + 1,
		day: 30,
	};
	c = new Date(year - 100, month, day);
	var MinDate = {
		year: parseInt(formatDate(c)),
		month: month + 1,
		day: day,
	};
	return { MaxDate, MinDate };
};
export function formatMsisdn(msisdn) {
	if (!isEmpty(msisdn)) {
		msisdn = msisdn.toString();
		return msisdn.substr(0, 3) + " " + msisdn.substr(3, 3) + " " + msisdn.substr(6, 2) + " " + msisdn.substr(8, 2);
	} else {
		return "";
	}
}
export const formatString = (template, ...args) => {
	return template.replace(/\{(\d+)\}/g, (match, index) => {
		return args[index] !== undefined ? args[index] : match;
	});
};

export const base64ToFile = (base64String, fileName) => {
	const arr = base64String.split(",");
	const mime = arr[0].match(/:(.*?);/)[1];
	const bstr = atob(arr[1]);
	let n = bstr.length;
	const u8arr = new Uint8Array(n);

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}

	return new File([u8arr], fileName, { type: mime });
};
export const blobUrlToFile = async (blobUrl, fileName) => {
	const response = await fetch(blobUrl);
	const blob = await response.blob();

	// ساخت یک فایل با استفاده از Blob
	const file = new File([blob], fileName, { type: blob.type });

	return file;
};
export const blobToBase64 = (blob) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => resolve(reader.result.split(",")[1]); // برش پیشوند Base64
		reader.onerror = reject;
		reader.readAsDataURL(blob);
	});
};
export const convertBlobToBase64 = async (blobUrl) => {
	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.responseType = "blob";
		xhr.onload = function () {
			const blob = xhr.response;

			const reader = new FileReader();
			reader.onloadend = function () {
				const base64Data = reader.result.split(",")[1]; // برش پیشوند Base64
				resolve(`data:image/jpeg;base64,${base64Data}`);
			};

			reader.readAsDataURL(blob);
		};

		xhr.onerror = function () {
			reject(new Error("خطا در دریافت Blob"));
		};

		xhr.open("GET", blobUrl);
		xhr.send();
	});
};
export const urltoFile = (url, filename = "newfile.jpg", mimeType = "image/jpeg") => {
	if (url.startsWith("data:")) {
		var arr = url.split(","),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[arr.length - 1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		var file = new File([u8arr], filename, { type: mime || mimeType });
		return Promise.resolve(file);
	}
	return fetch(url)
		.then((res) => res.arrayBuffer())
		.then((buf) => new File([buf], filename, { type: mimeType }));
};
export const base64ToImage = async (base64String, filename = "newfile.jpg", mimeType = "image/jpeg") => {
	if (base64String.startsWith("data:")) {
		var arr = base64String.split(","),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[arr.length - 1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		var file = new File([u8arr], filename, { type: mime || mimeType });
		return Promise.resolve(file);
	}
	return fetch(base64String)
		.then((res) => res.arrayBuffer())
		.then((buf) => new File([buf], filename + ".jpg", { type: mimeType }));
};

// const convertFileToBase64 = (file) => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onloadend = () => resolve(reader.result);
//     reader.onerror = reject;
//     reader.readAsDataURL(file);
//   });
// };

export const fileToBase64 = async (file) => {
	if (typeof file === "object") {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onloadend = () => resolve(reader.result);
			reader.onerror = reject;
			reader.readAsDataURL(file);
		});
	} else {
		return null;
	}
};

export const exportNormalFile = (base64String, isForm = false) => {
	try {
		// تبدیل رشته Base64 به بایت‌ها
		let byteCharacters = atob(base64String.split(",")[1]);
		let byteNumbers = new Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}
		let byteArray = new Uint8Array(byteNumbers);

		// ایجاد بلوب از بایت‌ها
		let blob = new Blob([byteArray], { type: "image/jpeg" });

		// بررسی حجم فایل
		if (blob.size > 500 * 1000) {
			// حداکثر حجم 500KB
			// کاهش حجم فایل
			let ratio = (500 * 1000) / blob.size;
			let resizedBlob = blob.slice(0, blob.size * ratio, "image/jpeg");

			// ایجاد فایل جدید از بلوب تغییر یافته
			let file = new File([resizedBlob], "resized_image.jpg", {
				type: "image/jpeg",
			});
			if (isForm) {
				let fd = new FormData();
				fd.append("file", file);
				return fd;
			} else {
				return file;
			}
		} else {
			if (isForm) {
				let fd = new FormData();
				fd.append("file", new File([blob], "original_image.jpg", { type: "image/jpeg" }));
				return fd;
			} else {
				// اگر حجم کمتر از 500KB باشد، فایل اصلی را برگردانید
				return new File([blob], "original_image.jpg", { type: "image/jpeg" });
			}
		}
	} catch (error) {
		console.error(error);
		return fetch(base64String)
			.then((res) => res.arrayBuffer())
			.then((buf) => new File([buf], "original_image.jpg", { type: "image/jpeg" }));
	}
};

export const fileToformData = async (file) => {
	try {
		if (file.size > 0) {
			let formdata = new FormData();
			formdata.append("file", file);
			return formdata;
		} else {
			return null;
		}
	} catch (error) {}
};
export const delay = (ms = 3000) => new Promise((resolve) => setTimeout(resolve, ms));
export const deleteAllCookies = () => {
	const cookies = document.cookie.split(";");

	for (let i = 0; i < cookies.length; i++) {
		const cookie = cookies[i];
		const eqPos = cookie.indexOf("=");
		const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
		document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
	}
};

export const getFieldDocument = (documentType) => {
	try {
		switch (documentType) {
			case 0:
				return "CertNoCard";
			case 1:
				return "Passport";
			case 2:
				return "PreparednessCard";
			case 3:
				return "RefugeeCard";
			case 4:
				return "IdentityCard";
			case 7:
				return "Fida";
			case 120:
				return "Passport";
			default:
				return "";
		}
	} catch (error) {
		return "";
	}
};
export const getFieldDocumentText = (documentType) => {
	try {
		switch (documentType) {
			case 0:
				return "کارت ملی";
			case 1:
				return "کارت گذرنامه";
			case 2:
				return "کارت امایش";
			case 3:
				return "کارت پناهندگی";
			case 4:
				return "کارت هویت";
			default:
				return "";
		}
	} catch (error) {
		return "";
	}
};
export const formatTime = (time = new Date()) => {
	try {
		let hours = time.getHours();
		let minutes = time.getMinutes();
		let seconds = time.getSeconds();
		return hours + ":" + ("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2);
	} catch (error) {
		return "";
	}
};

const applyRegex = (value, regexPattern) => {
	const regex = new RegExp(regexPattern, "g");
	return value.replace(regex, "");
};

export const regexFormater = (value) => {
	try {
		if (isEmpty(value)) {
			return "";
		}
		const formatter = {
			value: value,
			applyRegex: (regexPattern) => {
				formatter.value = applyRegex(formatter.value, regexPattern);
				return formatter.value;
			},
			removeSpace: () => {
				return formatter.applyRegex(/\s/g);
			},
			removeComma: () => {
				return formatter.applyRegex(/,/g);
			},
			removeCharacter: (regex) => {
				return formatter.applyRegex(regex);
			},
		};
		return formatter;
	} catch (error) {
		return "";
	}
};

export const ExportDocument = async (_file) => {
	try {
		let container = new DataTransfer();
		let temp = await urltoFile(_file);
		container.items.add(temp);
		let fd = new FormData();
		fd.append("file", container.files[0]);
		return fd;
	} catch (error) {
		return null;
	}
};
export const ExportDocumentFile = async (_file) => {
	try {
		let container = new DataTransfer();
		let temp = await urltoFile(_file);
		container.items.add(temp);
		return container.files[0];
	} catch (error) {
		return null;
	}
};
export const ExportFormDataDocument = async (_file) => {
	try {
		let container = new DataTransfer();
		let temp = await urltoFile(_file);
		container.items.add(temp);
		let fd = new FormData();
		fd.append("file", container.files[0]);
		const fileBlob = new Blob([fd], { type: "application/octet-stream" });
		return fileBlob;
	} catch (error) {
		return null;
	}
};

export const validateInput = ({
	t = null,
	validate = true,
	type = [""],
	min = null,
	max = null,
	length = null,
	typeOfValue = "",
	priceAmount = 0,
}) => {
	return {
		validator: (rules, value, getFieldValue) => {
			value = convertPersian(value);
			if (validate) if (isEmpty(value)) return Promise.reject(t("validation.required"));
			if (min !== null) return Promise.reject(formatString(t("validation.minChar"), min));
			if (max !== null) return Promise.reject(formatString(t("validation.maxChar"), max));
			if (length !== null) {
				let _regex = new RegExp(formatString(t("validation.regexDigitLength"), length));
				if (!_regex.test(value)) {
					return Promise.reject(t("validation.regex"));
				}
			}
			if (!isEmpty(type)) {
				if (type === "email") {
					if (!isEmpty(value)) {
						let _regex = new RegExp(t("validation.regexEmail"));
						if (!_regex.test(value)) {
							return Promise.reject(t("validation.regex"));
						}
					}
				}
				if (type === "url") {
					let _regex = new RegExp(t("validation.regexUrl"));
					if (!_regex.test(value)) {
						return Promise.reject(t("validation.regex"));
					}
				}
				if (type === "number") {
					let _regex = new RegExp(t("validation.regexDigit"));
					if (!_regex.test(value)) {
						return Promise.reject(t("validation.number"));
					}
				}
				if (type === "password") {
					if (value.length <= 8) {
						return Promise.reject(t("validation.minPassword"));
					}
					let _regexChar = new RegExp(t("validation.regexChar"));
					let _regexDigit = new RegExp(t("validation.regexDigit"));
					if (!_regexChar.test(value) || !_regexDigit.test(value)) {
						return Promise.reject(t("validation.complexPassword"));
					}
				}
				if (type === "msisdnOrg") {
					let _regex = new RegExp(t("validation.regexMsisdnOrg"));
					let _val = regexFormater(value.toString()).removeSpace();
					if (!_regex.test(_val)) {
						return Promise.reject(t("validation.regex"));
					}
				}
				if (type === "msisdn") {
					let _regex = new RegExp(t("validation.regexMsisdn"));
					let _val = regexFormater(value.toString()).removeSpace();
					if (!_regex.test(_val)) {
						return Promise.reject(t("validation.regex"));
					}
				}
				if (type === "msisdnFix") {
					let _regexFix = new RegExp(t("validation.regexMsisdnFix"));
					let _val = regexFormater(value.toString()).removeSpace();
					if (!_regexFix.test(_val)) {
						return Promise.reject(t("validation.regex"));
					}
				}
				if (type === "persian") {
					let _regexFix = new RegExp(t("validation.regexPersian"));
					if (!_regexFix.test(value)) {
						return Promise.reject(t("validation.onlypersian"));
					}
				}
				if (type === "english") {
					let _regexFix = new RegExp(t("validation.regexChar"));
					if (!_regexFix.test(value)) {
						return Promise.reject(t("validation.onlyEnglish"));
					}
				}
				if (type === "passport") {
					let _regexFix = new RegExp(t("validation.regexPassport"));
					if (!_regexFix.test(value)) {
						return Promise.reject(t("validation.regex"));
					}
				}
				if (type === "charge") {
					let _regex = new RegExp(t("validation.regexDigitComma"));
					if (!_regex.test(value.toString())) {
						return Promise.reject(t("validation.number"));
					}
					let amount = parseInt(regexFormater(value.toString()).removeComma());
					if (
						amount < parseInt(process.env.REACT_APP_MIN_CHARGE_BANK) ||
						amount % parseInt(process.env.REACT_APP_MIN_CHARGE_BANK) !== 0 ||
						amount > parseInt(process.env.REACT_APP_MAX_CHARGE_BANK)
					) {
						return Promise.reject(t("validation.charge"));
					}
				}
				if (type === "chargeWallet") {
					let _regex = new RegExp(t("validation.regexDigitComma"));
					if (!_regex.test(value)) {
						return Promise.reject(t("validation.number"));
					}
					let amount = parseInt(regexFormater(value).removeComma());
					if (amount < parseInt(priceAmount) || amount % parseInt(process.env.REACT_APP_MIN_CHARGE_BANK) !== 0) {
						return Promise.reject(t("validation.chargeWallet"));
					}
				}
				if (type === "image") {
				}
				if (type === "none") {
					return Promise.resolve();
				}
			}
			return Promise.resolve();
		},
		type: typeOfValue,
	};
};

export const findObjectToBase64ForRedux = async (obj) => {
	const newObj = Array.isArray(obj) ? [] : {}; // ساخت نسخه جدید از شیء به صورت خالی

	for (const key of Object.keys(obj)) {
		const value = obj[key];

		if (typeof value === "string" && value.startsWith("data:")) {
			// این یک رشته Base64 است و ما آن را به File تبدیل می‌کنیم
			const fileName = `file_${key}`; // این فقط یک نام فایل نمونه است، شما باید نام فایل واقعی را تعیین کنید
			newObj[key] = base64ToFile(value, fileName);
		} else if (typeof value === "object" && value !== null) {
			newObj[key] = await findObjectToBase64ForRedux(value); // بازگشتی تماس می‌گیریم برای شی‌های داخلی
		} else {
			newObj[key] = value; // کپی عادی مقادیر
		}
	}

	return newObj; // برگرداندن شیء جدید
};
export const findBase64ToObjectForRedux = async (obj) => {
	const newObj = Array.isArray(obj) ? [] : {}; // ساخت نسخه جدید از شیء به صورت خالی

	for (const key of Object.keys(obj)) {
		const value = obj[key];

		if (value instanceof File) {
			newObj[key] = await fileToBase64(value); // تبدیل فایل به Base64
		} else if (typeof value === "object" && value !== null) {
			newObj[key] = await findBase64ToObjectForRedux(value); // بازگشتی تماس می‌گیریم برای شی‌های داخلی
		} else {
			newObj[key] = value; // کپی عادی مقادیر
		}
	}

	return newObj; // برگرداندن شیء جدید
};
export const SwitchStateMsisdn = (state) => {
	switch (state) {
		case 0:
			return "پیش فعال";
		case 1:
			return "فعال";
		case 2:
			return "قطرنطینه";
		case 100:
			return "آزاد";
		case 101:
			return "رزرو";
		case 102:
			return "قطع دوطرفه";
		case 103:
			return "قطع یک طرفه";
		case 104:
			return "ترمینیت";
		case 105:
			return "قطع دوطرفه حقوقی";
		case 106:
			return "قطع دو طرفه بدلیل مستندات";
		case 107:
			return "قزنطینه برای آکشن";
		case 108:
			return "قرنطینه بدلیل مشکل سمته جی ای سی";
		default:
			return "";
	}
};
